import { supabase } from '@/integrations/supabase/client';
import { executeTrackedMutation } from '@/modules/shared/infrastructure/trackedMutation';
import type { PlatformWritePort, TrackingContext } from '../core/types';

export const supabasePlatformWritePort: PlatformWritePort = {
  upsertPlatformSetting(key: string, value: string, tracking?: TrackingContext) {
    return executeTrackedMutation({
      action: 'settings_updated',
      actorUserId: tracking?.actorUserId,
      entityType: 'platform_setting',
      entityId: key,
      mutation: async () => {
        const { error } = await supabase
          .from('platform_settings')
          .upsert({ key, value, updated_at: new Date().toISOString() }, { onConflict: 'key' });
        if (error) throw error;
        return { key };
      },
      detailsOnSuccess: { source: 'settings', key },
      detailsOnError: { source: 'settings', key, reason: 'upsert_platform_setting_failed' },
    });
  },
};
